import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-quote",
  "use": "icon-quote-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-quote\"><defs><style></style></defs><path d=\"M156.091 606.57a457.597 457.597 0 01221.68-392.516 50.844 50.844 0 1150.845 86.943A355.909 355.909 0 00289.81 453.529h16.779a152.532 152.532 0 11-152.532 152.533zm406.753 0a457.597 457.597 0 01221.68-392.008 50.844 50.844 0 1150.844 86.943 355.909 355.909 0 00-138.804 152.533h16.779A152.532 152.532 0 11560.81 606.57z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol